import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'
import { NavigationLinkDirective } from '../../../navigation-link.directive'
import { Store } from '../../store'
import * as utilities from '../utilities'
@ngCore.Component({
  imports: [
    NavigationLinkDirective,
    ds.ellipsisTooltip.Directive,
    utilities.Component,
  ],
  selector: 'atn-navbar-app-list-item',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /**
   * Set of app IDs that have utility pages (pages that are not main pages)
   */
  public readonly appsWithUtilityPagesSg = ngCore.computed(
    (apps = this.meFeature.contexts.selectors.availableApps.asSignal()) =>
      new Set(
        apps
          .filter(app => app.pages.some(p => p.display && !p.display.isMain))
          .map(app => app.id),
      ),
  )

  /**
   * Determines which icon is shown (only include the portion after `atn-`)
   *
   * @example
   * 'log-out'
   * 'folder'
   * 'clipboard'
   */
  public readonly iconSg = ngCore.input.required<string>({
    alias: 'icon',
  })

  /**
   * Shown when expanded
   */
  public readonly nameSg = ngCore.input.required<string>({
    alias: 'name',
  })

  /**
   * URL to navigate to when clicked
   */
  public readonly urlSg = ngCore.input<string | ngRouter.UrlTree>(undefined, {
    alias: 'url',
  })

  /** @see {@link ents.core.admin.App.ForUser} */
  public readonly appSg = ngCore.input<ents.core.admin.App.ForUser | undefined>(
    undefined,
    {
      alias: 'app',
    },
  )

  /**
   * Whether or not this item is currently active/selected
   */
  public readonly activeSg = ngCore.input<boolean>(false, {
    alias: 'active',
  })
}
